import BpkBreadcrumb, {
  BpkBreadcrumbItem,
} from '@skyscanner-internal/backpack-web/bpk-component-breadcrumb';
import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import {
  useOriginCityEntityId,
  useOriginContext,
  useUrlCountryName,
} from '@web-platform/travel-tools-flight-price-map-data-access-frontend';
import { getFlightPriceMapCountryUrl } from '@web-platform/travel-tools-flight-price-map-utils-frontend';
import { useLocation } from 'react-router-dom';

import STYLES from './BreadcrumbsSection.module.scss';

const cls = cssModules(STYLES);

export const BreadcrumbsSection = () => {
  const originCityEntityId = useOriginCityEntityId();
  const originContext = useOriginContext();
  const urlCountryName = useUrlCountryName();
  const { search } = useLocation();
  const matchedCity = originCityEntityId
    ? originContext?.cities?.find((c) => c.entityId === originCityEntityId)
    : undefined;

  const countryUrl =
    matchedCity && urlCountryName && originCityEntityId
      ? getFlightPriceMapCountryUrl(search)
      : undefined;

  return (
    <BpkBreadcrumb label="Breadcrumb navigation" className={cls('breadcrumbs')}>
      <BpkBreadcrumbItem href="/">Home</BpkBreadcrumbItem>
      <BpkBreadcrumbItem href="/travel-tools">Travel Tools</BpkBreadcrumbItem>
      {!matchedCity && originContext?.countryName && (
        <BpkBreadcrumbItem active>{originContext.countryName}</BpkBreadcrumbItem>
      )}
      {matchedCity && originContext?.countryName && countryUrl && (
        <BpkBreadcrumbItem href={countryUrl}>{originContext.countryName}</BpkBreadcrumbItem>
      )}
      {matchedCity && countryUrl && (
        <BpkBreadcrumbItem active>{matchedCity.name}</BpkBreadcrumbItem>
      )}
    </BpkBreadcrumb>
  );
};
